.card {
  background: white;
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  padding: 18px 20px 16px;
  cursor: pointer;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  transition:
    box-shadow .2s cubic-bezier(.2,.8,.4,1),
    border-color .2s ease,
    transform .2s cubic-bezier(.2,.8,.4,1);
  will-change: transform, box-shadow;
  box-sizing: border-box;
}

.card:hover {
  box-shadow: 0 4px 20px rgba(60,64,67,.14), 0 1px 6px rgba(60,64,67,.1);
  border-color: #c5c8cc;
  transform: translateY(-2px);
}

.card:active {
  transform: translateY(0);
  box-shadow: var(--shadow-sm);
}

/* Header row */
.cardHeader {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
}

.nameRow {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.dot {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  flex-shrink: 0;
}

.dotActive { background: var(--green); box-shadow: 0 0 0 3px rgba(30,142,62,.15); }
.dotPaused { background: var(--yellow); box-shadow: 0 0 0 3px rgba(227,116,0,.15); }

.name {
  font-size: 15px;
  font-weight: 600;
  color: var(--ink);
  font-family: 'Google Sans', sans-serif;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.arrow {
  color: var(--muted2);
  flex-shrink: 0;
  transition: transform .2s ease, color .15s;
  margin-top: 1px;
}

.card:hover .arrow {
  transform: translateX(3px);
  color: var(--blue);
}

/* Teams / prefix */
.route {
  display: flex;
  align-items: center;
  gap: 5px;
  flex-wrap: wrap;
  font-size: 12px;
  color: var(--muted2);
}

.route code {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 140px;
}

.moreTeams {
  font-size: 11.5px;
  color: var(--muted2);
  white-space: nowrap;
}

/* Feature pills */
.pills {
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
  margin-top: auto;
}

.pill {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 3px 8px;
  border-radius: 20px;
  font-size: 11.5px;
  font-weight: 500;
  font-family: 'Google Sans', sans-serif;
  white-space: nowrap;
}

.pillActive   { background: #e6f4ea; color: #1e8e3e; }
.pillPaused   { background: #fef7e0; color: #e37400; }
.pillNudge    { background: #fff8e1; color: #f9a825; }
.pillDigest   { background: #f3e8fd; color: #7b57d6; }
.pillPersonal { background: #e8f0fe; color: #1a73e8; }
.pillEscl     { background: #fce8e6; color: #c5221f; }
.pillHours    { background: #e8f0fe; color: #1a73e8; }
.pillAuthor   { background: #e0f2f1; color: #00897b; }
.pillTag      { background: #e0f2f1; color: #00695c; }
.pillDm       { background: #e3f2fd; color: #1565c0; }
